import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  retrieveInitiative,
  retrieveInitiativeAncestry,
} from '../../../../modules/initiatives.js';
import AuthorizedAction from '../../../AuthorizedAction.js';
import {
  retrieveInitiativeStakeholderParticipations,
  updateStakeholderParticipation,
} from '../../../../modules/stakeholderParticipations.js';

const mapDispatchToProps = (
  dispatch,
  { initiative, stakeholderParticipation }
) =>
  bindActionCreators(
    {
      retrieveInitiative: () =>
        retrieveInitiative(initiative.type, initiative.id),
      retrieveInitiativeAncestry: () =>
        retrieveInitiativeAncestry(initiative.type, initiative.id),
      retrieveStakeholderParticipations: () =>
        retrieveInitiativeStakeholderParticipations(
          initiative.type,
          initiative.id
        ),
      toggleCompleted: () => {
        return updateStakeholderParticipation(stakeholderParticipation.id, {
          completed: !stakeholderParticipation.completedAt,
        });
      },
    },
    dispatch
  );

class StakeholderParticipationCompletionButton extends React.PureComponent {
  state = {
    submitting: false,
  };

  refreshInitiative = () => {
    const {
      retrieveInitiative,
      retrieveInitiativeAncestry,
      retrieveStakeholderParticipations,
    } = this.props;

    return Promise.all([
      retrieveInitiative(),
      retrieveInitiativeAncestry(),
      retrieveStakeholderParticipations(),
    ]);
  };

  handleClick = () => {
    const { toggleCompleted } = this.props;

    this.setState({ submitting: true });

    toggleCompleted()
      .then(this.refreshInitiative)
      .then(() => this.setState({ submitting: false }));
  };

  render() {
    const {
      stakeholderParticipation: { completedAt, id },
      isPreview,
      initiative,
    } = this.props;
    const { submitting } = this.state;

    return (
      <span>
        {!isPreview &&
        initiative.project[
          `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
        ] ? (
          <AuthorizedAction
            action="update"
            subject={`${initiative.type}Initiative`}
          >
            <Button
              block
              bsStyle={completedAt ? 'default' : 'primary'}
              disabled={submitting}
              onClick={this.handleClick}
            >
              {completedAt ? 'Completed' : 'Mark Completed'}
            </Button>
          </AuthorizedAction>
        ) : null}
      </span>
    );
  }
}

StakeholderParticipationCompletionButton = connect(
  null,
  mapDispatchToProps
)(StakeholderParticipationCompletionButton);

export default StakeholderParticipationCompletionButton;
